import React, { useRef, useState, useEffect, Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

import helpers from '../../../../utils/helpers';

const Referral = ({
  sitekey, onSubmitClick, isSubmitting, submitStarted, customErrors, env, isMobileMode, isMobileModalFlow,
}) => {
  const [shareEmail, setShareEmail] = useState('');
  const [shareEmailError, setShareEmailError] = useState('');
  const recaptchaRef = useRef(null);
  const isTestEnv = env === 'test';

  useEffect(() => {
    setShareEmailError(customErrors.shareEmail);
  }, [customErrors.shareEmail]);

  const validateEmail = (value) => {
    setShareEmailError((!value || !helpers.validateEmail(value) || value.includes('+')) ? 'Please enter a valid email address' : '');
  };

  const submitDisabled = () => shareEmail.length === 0 || shareEmailError.length > 0;

  const handleEmailChange = (email) => {
    validateEmail(email);
    setShareEmail(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!submitDisabled() && !isSubmitting) {
      submitStarted();
      if (isTestEnv) {
        validateEmail();
        onSubmitClick(
          'test-token',
          { referral: shareEmail.length > 0 ? { email: shareEmail } : {}, skip_user: true },
          shareEmailError.length > 0,
        );
      } else {
        recaptchaRef.current.reset();
        recaptchaRef.current.executeAsync().then((token) => {
          validateEmail();
          onSubmitClick(
            token,
            { referral: shareEmail.length > 0 ? { email: shareEmail } : {} },
            shareEmailError.length > 0,
          );
        });
      }
    }
  };

  return (
    <Fragment>
      <div className={cx({ 'app-selection-mobile-container': isMobileMode && !isMobileModalFlow })}>
        <div className={cx('report-analysis-refferal', isMobileMode && isMobileModalFlow ? 'report-analysis-refferal-mobile-modal' : '')}>
          <div className="flex-no-shrink d-flex flex-wrap flex-column w-100">
            <h2 className="report-analysis-search-header referral-header text-16 text-uppercase d-flex flex-column align-items-center">
              <div className="report-analysis-unlock flex-no-shrink" />
              Unlock your free report!
            </h2>
            <p className="text-16 text-black text-center mb-lg">
              Share your love for mobile insights with a colleague and get access to your free report.
            </p>
            <p className="text-16 text-black text-center mb-sm">
              But Hurry! <br />
              Insights on your competition are waiting...
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row m-a-0 p-a-0 w-100">
              <div className="col-md-12 p-a-0">
                <fieldset className={cx('form-group pos-rel', { 'has-error': Boolean(shareEmailError) })}>
                  <input
                    className="form-control"
                    placeholder="Colleague's Business Email"
                    type="text"
                    onChange={e => handleEmailChange(e.target.value)}
                    value={shareEmail}
                  />
                  {shareEmailError &&
                    <div className="error-message" >
                      {shareEmailError}
                    </div>
                  }
                </fieldset>
              </div>
            </div>
            <div className="row m-a-0 p-a-0 w-100">
              <div className="d-flex flex-column col-md-12 p-a-0 justify-content-end align-items-end" style={{ height: 95 }}>
                { isSubmitting && <div className="verifying text-blue text-center w-100">Verifying..</div>}
                <button
                  className={cx('btn report-analysis-submit-btn m-t-0 report-analysis-share-btn', {
                    disabled: submitDisabled(),
                    'processing disabled': isSubmitting,
                  })}
                  type="submit"
                >
                  Share
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {!isTestEnv &&
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={sitekey}
        />
      }
    </Fragment>
  );
};

Referral.propTypes = {
  onSubmitClick: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  sitekey: PropTypes.string.isRequired,
  submitStarted: PropTypes.func.isRequired,
  customErrors: PropTypes.object,
  env: PropTypes.string,
  isMobileMode: PropTypes.bool,
  isMobileModalFlow: PropTypes.bool,
};

Referral.defaultProps = {
  customErrors: {},
};

export default Referral;
